import * as React from "react";
import AppReduxInit from "@/ReactComponents/AppReduxInit";

const AppReduxInitView = props => <AppReduxInit {...props} />;

export default AppReduxInitView;
